import EventActionProto from '../event-action-proto'
import CompanyUser from "../../model2/company-user-new/company-user"
import {SessionEventData} from "../@type"
import {BUS_COMPANY_USERS_CHANGED} from "../../model2/company-user-new/@const"
import User from "../../model2/user/user"


// i think we dont use it anymore...

/**
 * Handles the creation of a new CompanyUser in the session.
 * Extends EventActionProto to process the event and update session state.
 */
export default class EventCompanyUsersNew_v2 extends EventActionProto {

    public header : any

    /**
     * Constructor initializes the event with session event data.
     * @param sessionEvent - The event data received from the session.
     */
    constructor(sessionEvent:SessionEventData) {
        // Call parent constructor with uid, data, and companyId
        super(sessionEvent.uid, sessionEvent.data, sessionEvent.companyId)

        // Store event header information for later use
        this.header     = {
            event       : sessionEvent.event,
            isBulkUpdate: sessionEvent.isBulkUpdate,
        }
    }

    /**
     * Processes the event:
     * - Ensures the user exists in session.users, adding if missing.
     * - Creates a new CompanyUser model from event data.
     * - Adds the CompanyUser to the appropriate session collection (active or deleted).
     * - Triggers a bus event if a new active CompanyUser is added.
     * - Calls the parent process method and sends a bus update.
     */
    process() {

        // Ensure the user exists in session.users; add if not present
        let sessionUser = gd.session.users.get(this.data.userId);
        if (!sessionUser) {
            gd.session.users.add(new User(this.data.user))
        }

        // Create a new CompanyUser model with the provided data
        const newCompanyUserModel = new CompanyUser({
            userId              : this.data.userId,
            companyId           : this.data.companyId,
            companyRole         : this.data.companyRole,
            departmentId        : this.data.departmentId,
            reportToUserId      : this.data.reportToUserId,
            workWeek            : this.data.workWeek,
            workdayDurations    : this.data.workdayDurations,

            financeInternalCost : this.data.financeInternalCost,
            financeExternalCost : this.data.financeExternalCost,

            isActivated         : this.data.isActivated,
            isDeleted           : this.data.isDeleted
        });

        // If the user is marked as deleted, add to deletedCompanyUsers if not already present
        if (_.get(this.data, 'isDeleted') === true) {
            if (!gd.session.deletedCompanyUsers.get(newCompanyUserModel.id)) {
                gd.session.deletedCompanyUsers.add(newCompanyUserModel)
            }
        } else {
            // Otherwise, add to active companyUsers if not already present
            if (!gd.session.companyUsers.get(newCompanyUserModel.id)) {
                gd.session.companyUsers.add(newCompanyUserModel)
                // Notify listeners that company users have changed
                gd.bus.triggerEvent(BUS_COMPANY_USERS_CHANGED)
            }
        }

        super.process()
        this._sendBusUpdate()
    }

    /**
     * Sends a model bus update for the new company user.
     * Notifies other system components of the new or updated company user.
     * @private
     */
    _sendBusUpdate() {
        const companyUserId = this.data.companyId + "-" + this.data.userId
        gd.modelBus.newUpdate('company-user', 'new', companyUserId, this.data, this.header)
    }
};
